import { ModalTitle } from '@carrot/style-components/modal/title';
import { Modal as ModalComponent } from './modal';
import { ModalActions } from '@carrot/style-components/modal/actions';

export const Modal = Object.assign(ModalComponent, {
  Actions: ModalActions,
  Title: ModalTitle
});
